export const USER_INFO = 'USER_INFO';

export const USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const USER_LOGOUT_FAIL = 'USER_LOGOUT_FAIL';

export const USER_GET_INFO = 'USER_GET_INFO';
export const USER_GET_INFO_SUCCESS = 'USER_GET_INFO_SUCCESS';
export const USER_GET_INFO_FAIL = 'USER_GET_INFO_FAIL';
export const USER_GET_INFO_CLEAR = 'USER_GET_INFO_CLEAR';

export const USER_CORPORATE = 'USER_CORPORATE';
export const USER_CORPORATE_SUCCESS = 'USER_CORPORATE_SUCCESS';
export const USER_CORPORATE_FAIL = 'USER_CORPORATE_FAIL';

export const USER_SET_THEME = 'USER_SET_THEME';

export const USER_GET_PERMISSIONS_REQUEST = 'USER_GET_PERMISSIONS_REQUEST';
export const USER_GET_PERMISSIONS_SUCCESS = 'USER_GET_PERMISSIONS_SUCCESS';
export const USER_GET_PERMISSIONS_FAIL = 'USER_GET_PERMISSIONS_FAIL';

export const USER_SET_MESSAGE_ICON_COUNT = 'USER_SET_MESSAGE_ICON_COUNT';

export const USER_MESSAGE_INFO_VISIBLE_OPEN = 'USER_MESSAGE_INFO_VISIBLE_OPEN';
export const USER_MESSAGE_INFO_VISIBLE_CLOSE = 'USER_MESSAGE_INFO_VISIBLE_CLOSE';

export const USER_CONSENT_NEED_REQUEST = 'USER_CONSENT_NEED_REQUEST';
export const USER_CONSENT_NEED_SUCCESS = 'USER_CONSENT_NEED_SUCCESS';
export const USER_CONSENT_NEED_FAIL = 'USER_CONSENT_NEED_FAIL';

export const USER_CONSENT_SAVE_REQUEST = 'USER_CONSENT_SAVE_REQUEST';
export const USER_CONSENT_SAVE_SUCCESS = 'USER_CONSENT_SAVE_SUCCESS';
export const USER_CONSENT_SAVE_FAIL = 'USER_CONSENT_SAVE_FAIL';
